import { useMutation } from "@tanstack/react-query";
import { privateApi } from "../../../api/api";
import { ValidationErrorResponse } from "../../common/response/ValidationErrorResponse";
import { UpdateLinkRateResponse } from "../response/UpdateLinkRateResponse";
import { UpdateLinkRateForm } from "../schema/UpdateLinkRateSchema";

export const useUpdateLinkRatePlan = () => {
    return useMutation({
        mutationFn: async (values: {
            rateId: string;
            formData: UpdateLinkRateForm;
        }) => privateApi.put(`/v4/link-rate-plan/${values.rateId}`, values.formData),
        onSuccess: async (response) => {
            try {
                const validationResult = UpdateLinkRateResponse.safeParse(response.data);

                if (!validationResult.success) {
                    console.error("Validation failed:", validationResult.error.errors);
                    throw new Error("Invalid update rate data format");
                }

                return validationResult.data;
            } catch (error) {
                console.error('Failed to update rate', error);
                throw error;
            }
        },
        onError: (error) => {
            const validationResult = ValidationErrorResponse.safeParse((error as any).response.data);

            if (!validationResult.success) {
                console.error("Validation failed:", validationResult.error.errors);
                throw new Error("Invalid rate data format");
            } else {
                console.error('Failed to update rate', error);
                throw error;
            }
        },
    });
};